module.exports = __webpack_public_path__ + "img/Choice.6478e011.gif";